import type { ElibooApi, NuasApp, PageResult } from '@eliboo/api-models';
import type { ShowLoadingParams } from '@eliboo/web-kit';
import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { DOCUMENT, effect, inject, Injectable, Injector, signal } from '@angular/core';
import { DA_SERVICE_TOKEN } from '@delon/auth';
import { CacheService } from '@delon/cache';
import { useRouterLoading } from '@eliboo/angular/hooks';
import { PageLoadingKit } from '@eliboo/web-kit';
import { getEnv } from '@env';
import { catchError, of, tap } from 'rxjs';

import { getTokenModel } from '../../transfer/transfer.component';
// import { getTokenModel } from '../../pages/sign-in/login.component';
import { BridgeService } from './bridge.service';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class AppService {
  http = inject(HttpClient);
  userService = inject(UserService);
  tokenService = inject(DA_SERVICE_TOKEN);
  cacheService = inject(CacheService);
  injector = inject(Injector);
  env = getEnv();
  bridgeService = inject(BridgeService);
  user = signal<NuasApp.NuasMemberUserAccountAndBaseInfoDTO | null>(null);
  initCount = signal(0);
  dom = inject(DOCUMENT);
  pageLoadingSrv = new PageLoadingKit<ShowLoadingParams>({
    document: this.dom,
    innerHTML: `<div class="flex w-full h-full items-center justify-center">
    <span class="loading loading-bars loading-lg text-primary"></span>
    <span class="text-sm ml-2">\${text}</span>
    </div>`,
    paramsKeys: ['text'],
  });

  // http://192.168.2.18:16666/eliboo-api/api/ufx/financial-rules-setting/app/configs/ get
  getFinancialRulesSetting(key: string) {
    return this.http.get<PageResult<ElibooApi.FinancialRulesSetting>>(`/eliboo-api/api/ufx/financial-rules-setting/app/configs/${key}`);
  }

  init(first = false) {
    this.pageLoadingSrv.init();
    let res$: Observable<unknown> = of(null);
    let skipInit = false;
    // flutter 获取用户信息
    let directGetInfo = true;
    // 不走转换页
    let noTransferPage = false;
    directGetInfo = !window.location.href.includes('_noDirectGetInfo=true');
    noTransferPage = !window.location.href.includes('/transfer?');
    if (first) {
      try {
        skipInit = window.location.href.includes('_skipAppInit=true');
      } catch (error) {
        console.log('获取 window.location.href 失败');
      }
    }

    if (noTransferPage) {
      const token = this.bridgeService.getSysInfo('token');
      if (token) {
        console.log('token', token);
        this.tokenService.set(getTokenModel(token));
      }
    }

    if (!skipInit) {
      if (this.tokenService.get()?.token) {
        res$ = this.userService.getUserInfoSequentially(directGetInfo).pipe(
          tap((res) => {
            console.log('getUserInfo', res);
            const user = res;
            this.user.set(user);
            this.cacheService.set('user', user);
          }),
          catchError((err) => {
            // console.log('getUserInfo error', err);
            this.tokenService.clear();
            return of(true);
          }),
        );
      }
    }
    return res$.pipe(
      tap(() => {
        this.initCount.update((count) => count + 1);
        if (first) this.pageLoadingSrv.hide();
        this.dom.body.setAttribute('eliboo-version', this.env.versionCode.toString());
      }),
    );
  }
}
function registePageLoading(pageLoadingSrv: PageLoadingKit<ShowLoadingParams>) {
  const routerLoading = useRouterLoading().loading;
  effect(() => {
    if (routerLoading()) {
      pageLoadingSrv.show({ text: '加载中 · · ·' });
    } else {
      pageLoadingSrv.hide();
    }
  });
}
